import * as React from 'react';
import styled from '@mui/material/styles/styled';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

interface HtmlTooltipProps extends TooltipProps {
    certified: boolean;
    certifiedColor?: string;
}

export const HtmlTooltip = styled(({ className, certified, ...props }: HtmlTooltipProps) => {
    return <Tooltip {...props} classes={{ popper: className }} children={props.children} />;
})(({ theme, certified, certifiedColor }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.background.default,
        maxWidth: 282,
        minWidth: 282,
        padding: '0',
        border: '1px solid',
        borderColor: certifiedColor
            ? certifiedColor
            : certified
              ? theme.palette.success.main
              : theme.palette.primary.main,
        borderRadius: '3px',
        color: theme.palette.text.primary,
    },
}));
